import {Stack,ButtonGroup,Button} from '@mui/material';

// Shared by DetailForm.js and DetailFormPopup.js - lays out the main buttons and the model's
// methods() groups as rows of button groups.
// Rows use flex gap (useFlexGap), not Stack spacing margins, so whatever wraps to the next line
// starts flush with the left edge, and wrapped lines get a vertical gap between them.
// Optional method keys (backend methods()):
//   newLine  - true on the group's first visible method: the group starts a row of its own
//   size     - on the group's first visible method: 'small' (default) | 'medium' | 'large'
//   variant  - per method: 'outlined' (default) | 'contained' | 'text'

export const getVisibleMethodGroups=(recordRules,readOnly)=>(recordRules?.methods??[])
    .map((methodGroup)=>Object.values(methodGroup||{}).filter((method)=>{
        const shouldShow=method.onReadOnlyInvoke===true?!readOnly:readOnly;
        return shouldShow;
    }))
    .filter((visibleMethods)=>visibleMethods.length>0);

const MethodButtonRows=({mainButtons,methodGroups,handleClickMethodButton,application,sx})=>{
    const rows=[[]];
    methodGroups.forEach((visibleMethods)=>{
        if(visibleMethods[0]?.newLine===true&&(rows.length>1||rows[0].length>0||mainButtons)){
            rows.push([]);
        }
        rows[rows.length-1].push(visibleMethods);
    });

    return (
        <Stack direction="column" useFlexGap spacing={1} sx={sx}>
            {rows.map((row,rowKey)=>(
                <Stack key={rowKey} direction="row" useFlexGap spacing={1} flexWrap="wrap" alignItems="center">
                    {rowKey===0&&mainButtons}
                    {row.map((visibleMethods)=>(
                        <ButtonGroup
                            key={visibleMethods[0].name}
                            size={visibleMethods[0].size??'small'}
                            sx={{minHeight:24,flexWrap:'wrap',rowGap:1}}>
                            {visibleMethods.map((method)=>(
                                <Button
                                    key={method.name}
                                    color={method.color}
                                    variant={method.variant??'outlined'}
                                    sx={{whiteSpace:'nowrap'}}
                                    onClick={()=>handleClickMethodButton(method)}>
                                    {application.getLocale(method?.label)}
                                </Button>
                            ))}
                        </ButtonGroup>
                    ))}
                </Stack>
            ))}
        </Stack>
    );
}

export default MethodButtonRows;
